import * as Yup from 'yup';

export const maxLengthValidation = (length, t = null) => {
  let message =
    t !== null ? `${t('Mustbeatmost')} ${length} ${t('characters long')}` : `must be at most ${length} characters long`;
  return Yup.string().max(length, message);
};

export const maxDigitsValidation = (maxDigits, t = null) => {
  let message =
    t !== null ? `${t('Mustbeatmost')} ${maxDigits} ${t('digitslong')}` : `must be at most ${maxDigits} digits long`;
  return Yup.number().test('maxDigits', message, value => !value || value.toString().length <= maxDigits);
};
